import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";

const PublicRoute = () => {
  const { token, selectedBranch, mode } = useSelector((state) => state.auth);

  return token || (token && mode === "am") ? ( //Solusi Bypass Kalau Api Branch Mati
    // return (token && selectedBranch) || (token && mode === "am") ? (
    <Navigate to={AUTHENTICATED_ENTRY} />
  ) : (
    <Outlet />
  );
};

export default PublicRoute;
